var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedBankThin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M36.5 17.9544L37.0057 18.5083C37.1876 18.3422 37.2764 18.0974 37.2431 17.8533C37.2099 17.6092 37.059 17.397 36.8393 17.2856L36.5 17.9544ZM13.5 17.9544L13.1607 17.2856C12.941 17.397 12.7901 17.6092 12.7569 17.8533C12.7236 18.0974 12.8124 18.3422 12.9943 18.5083L13.5 17.9544ZM14.7778 19.1211L14.2721 19.6749C14.4103 19.8011 14.5906 19.8711 14.7778 19.8711L14.7778 19.1211ZM35.2222 19.1211L35.2222 19.8711C35.4094 19.8711 35.5897 19.8011 35.7279 19.675L35.2222 19.1211ZM24.6935 12.2765L24.3543 11.6077L24.6935 12.2765ZM24.8052 12.2235L24.54 11.522L24.8052 12.2235ZM25.3065 12.2765L25.6458 11.6077L25.3065 12.2765ZM25.1948 12.2235L25.46 11.522L25.1948 12.2235ZM13.8393 18.6233L25.0328 12.9454L24.3543 11.6077L13.1607 17.2856L13.8393 18.6233ZM24.9672 12.9454L36.1607 18.6233L36.8393 17.2856L25.6458 11.6077L24.9672 12.9454ZM15.2835 18.5672L14.0057 17.4006L12.9943 18.5083L14.2721 19.6749L15.2835 18.5672ZM35.9943 17.4006L34.7165 18.5672L35.7279 19.675L37.0057 18.5083L35.9943 17.4006ZM35.2222 18.3711L14.7778 18.3711L14.7778 19.8711L35.2222 19.8711L35.2222 18.3711ZM25.0328 12.9454C25.0472 12.9381 25.0579 12.9327 25.0672 12.928C25.0764 12.9234 25.0819 12.9207 25.0853 12.9191C25.0915 12.9161 25.0842 12.9198 25.0705 12.925L24.54 11.522C24.4653 11.5502 24.3953 11.5868 24.3543 11.6077L25.0328 12.9454ZM25.6458 11.6077C25.6047 11.5868 25.5347 11.5502 25.46 11.522L24.9295 12.925C24.9158 12.9198 24.9085 12.9161 24.9147 12.9191C24.9181 12.9207 24.9236 12.9234 24.9328 12.928C24.9421 12.9327 24.9528 12.9381 24.9672 12.9454L25.6458 11.6077ZM25.0705 12.925C25.0251 12.9422 24.9749 12.9422 24.9295 12.925L25.46 11.522C25.1636 11.4099 24.8364 11.4099 24.54 11.522L25.0705 12.925Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 411",
    d: "M13.5 36.1211H36.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 412",
    d: "M17.5 23.1211V32.1211",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 413",
    d: "M22.5 23.1211V32.1211",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 415",
    d: "M27.5 23.1211V32.1211",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 414",
    d: "M32.5 23.1211V32.1211",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedBankThin);
export default __webpack_public_path__ + "static/media/ic-shared-bank-thin.045b43f6a8760e9f003230720f09dfcd.svg";
export { ForwardRef as ReactComponent };